<template>
  <div id="paginaVerificaBilancio">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Verifica Bilancio Progetti</b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropProgetti" ref="dropProgetti"
                  :dataSource="listaProgetti" :fields="listaProgettiFields"
                  :change="onProgettoChange" v-model="progettoCorrente"
                  placeholder="Seleziona un progetto"></ejs-dropdownlist>
              </b-col>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-alert variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>

              <b-col xl="12" md="12" class="mt-4" v-show="mostraRiepilogo">
                <h3>Riepilogo Progetto</h3>
              </b-col>
              <b-col xl="12" md="12" v-show="mostraRiepilogo">
                <b-card tag="article" class="mb-0">
                  <b-card-body class="mb-0" v-if="mostraCantelli">
                    <b-row>
                      <b-col xl="12" md="12" class="mb-0">
                        <h3>Totale entrate</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePreventivoEntrate" class="h5">Totale Preventivo</label>
                        <ejs-numerictextbox id="totalePreventivoEntrate" v-model="totalePreventivoEntrate"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Preventivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleConsuntivoEntrate" class="h5">TotaleConsuntivo</label>
                        <ejs-numerictextbox id="totaleConsuntivoEntrate" v-model="totaleConsuntivoEntrate"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Consuntivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="scostamentoEntrate" class="h5">Scostamento</label>
                        <ejs-numerictextbox id="scostamentoEntrate" v-model="scostamentoEntrate"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="raggiungimentoPercEntrate" class="h5">Raggiungimento %</label>
                        <ejs-numerictextbox id="raggiungimentoPercEntrate" v-model="raggiungimentoPercEntrate"
                          floatLabelType="Never" cssClass="" format="###.##" placeholder="Raggiungimento %"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl="12" md="12">
                      <h3>Totale uscite</h3>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePreventivoUscite" class="h5">Totale Preventivo</label>
                        <ejs-numerictextbox id="totalePreventivoUscite" v-model="totalePreventivoUscite"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Preventivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleConsuntivoUscite" class="h5">TotaleConsuntivo</label>
                        <ejs-numerictextbox id="totaleConsuntivoUscite" v-model="totaleConsuntivoUscite"
                          floatLabelType="Never" cssClass="" format="€ ###.##" placeholder="Consuntivo"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="scostamentoUscite" class="h5">Scostamento</label>
                        <ejs-numerictextbox id="scostamentoUscite" v-model="scostamentoUscite"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="raggiungimentoPercUscite" class="h5">Raggiungimento %</label>
                        <ejs-numerictextbox id="raggiungimentoPercUscite" v-model="raggiungimentoPercUscite"
                          floatLabelType="Never" cssClass="" format="###.##" placeholder="Raggiungimento %"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                  <b-card-body class="mb-0" v-else>
                    <!-- card body -->
                    <b-row>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePersonale" class="h5">Totale Personale</label>
                        <ejs-numerictextbox id="totalePersonale" v-model="totalePersonale"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleAllestimenti" class="h5">Totale Allestimenti</label>
                        <ejs-numerictextbox id="totaleAllestimenti" v-model="totaleAllestimenti"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totaleAttrezzature" class="h5">Totale Attrezzature</label>
                        <ejs-numerictextbox id="totaleAttrezzature" v-model="totaleAttrezzature"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3" class="mb-2">
                        <label for="totalePubblicita" class="h5">Totale Pubblicita</label>
                        <ejs-numerictextbox id="totalePubblicita" v-model="totalePubblicita"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                      <b-col xl="3" md="3">
                        <label for="totaleLavoriWifi" class="h5">Totale Lavori Wifi</label>
                        <ejs-numerictextbox id="totaleLavoriWifi" v-model="totaleLavoriWifi"
                          floatLabelType="Never" cssClass="" format="€ ###.##"
                          showSpinButton="false" showClearButton="true" :readonly="true" />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>

              </b-col>

              <!-- Button:  -->
              <b-col xl="12" md="12" class="mt-2" v-show="mostraDownload">
                <ejs-button id="downloadExcel" @click.native="downloadXls(false)">Scarica Excel</ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import { LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin,
  LinkPlugin, AlertPlugin, ToastPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
  Aggregate,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(DropDownListPlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiRicercaSpesaUrl = '/demo/api/altraspesa/ricerca'
const apiDownloadSpesaUrl = '/demo/api/altraspesa/export_xls'
// API ricerca distinte per anno

export default Vue.extend({
  components: {},
  data() {
    return {
      initial: true,
      dataOggi: new Date(),
      // tmp
      nonMostrare: false, // utile per non cancellare codice in editing
      // generali
      settings: {
        formatoData: { type: "date", format: "dd-MM-yyyy" }, // da usare per grid
        formatoOra: { skeleton: "Hm" },
        //formatoOra: 'HH:mm',
        formatoOraGrid: { type: "dateTime", format: "HH:mm" }, // da usare per grid
        formatoDatepicker: "dd-MM-yyyy", // da usare per i datepicker
        intervalloOra: 5,
        firstDayOfWeek: 1,
      },
      // per gestione progetti
      listaProgetti: [
        { label: "Alfabeto Culturale", id: "alfabeto" },
        { label: "Facciamone un dramma", id: "facciamoneUnDramma" },
        { label: "Premio Cantelli 2024", id: "cantelli2024" },
        { label: "Premio Cantelli 2026", id: "cantelli2026" },
        { label: "Altro", id: "altro" },
      ],
      listaProgettiFields: { value: "id", text: "label" },


      totalePersonale: 0,
      totaleAllestimenti: 0,
      totaleAttrezzature: 0,
      totalePubblicita: 0,
      totaleLavoriWifi: 0,

      // info cantelli
      totalePreventivoEntrate: 0,
      totaleConsuntivoEntrate: 0,
      scostamentoEntrate: 0,
      raggiungimentoPercEntrate: 0,
      totalePreventivoUscite: 0,
      totaleConsuntivoUscite: 0,
      scostamentoUscite: 0,
      raggiungimentoPercUscite: 0,

      progettoCorrente: null,
      speseProgetti: null,
      preventivoSpese: null,

      mostraRiepilogo: false,
      mostraCantelli: false,
      mostraDownload: false,

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: true,
        },
        filterOptions: { type: "Excel" },
        toolbarOptions: [
          {
            text: "Download riepilogo",
            tooltipText: "Download riepilogo",
            prefixIcon: "e-save",
            id: "download-riepilogo",
          },
          "Search",
        ],
        groupOptions: { showDropArea: false, columns: ['gruppo'] },
        sortOptions: { columns: [{ field: "data", direction: "Ascending" }] },
      },
    };
  },
  created() {
    console.log("Pagina Bilancio Progetti Creata");
    // inizializzazione elenchi dal backend
    // ottenere elenco progetti

  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit, ForeignKey, Aggregate, Group],
    // per multiselect
    multiselect: [CheckBoxSelection],
  },
  methods: {
    onProgettoChange: function (e) {
      console.log("Recupero dati progetto selezionato");

      if ((this.progettoCorrente != 'cantelli2024') && (this.progettoCorrente != 'cantelli2026')) {
        const datiDaInviare = {
          progetto: this.progettoCorrente,
        };
        useJwt.post(apiRicercaSpesaUrl, datiDaInviare).then((r) => {
          console.log("spese progetto")
          console.log(r.data)
          this.speseProgetti = r.data['consuntivo']
          this.mostraRiepilogo = true
          this.mostraCantelli = false
          this.mostraDownload = true
          this.totalePersonale = 0
          this.totaleAllestimenti = 0
          this.totaleAttrezzature = 0
          this.totalePubblicita = 0
          this.totaleLavoriWifi = 0

          if (this.speseProgetti['personale']) {
            this.speseProgetti['personale'].forEach((obj) => {
              this.totalePersonale += +obj.importo
            })
          }
          if (this.speseProgetti['allestimenti']) {
            this.speseProgetti['allestimenti'].forEach((obj) => {
              this.totaleAllestimenti += +obj.importo
            })
          }
          if (this.speseProgetti['attrezzature']) {
            this.speseProgetti['attrezzature'].forEach((obj) => {
              this.totaleAttrezzature += +obj.importo
            })
          }
          if (this.speseProgetti['pubblicita']) {
            this.speseProgetti['pubblicita'].forEach((obj) => {
              this.totalePubblicita += +obj.importo
            })
          }
          if (this.speseProgetti['wifi']) {
            this.speseProgetti['wifi'].forEach((obj) => {
              this.totaleLavoriWifi += +obj.importo
            })
          }
        })
      } else {
        // gestire ricerca cantelli
          this.mostraRiepilogo = true
          this.mostraDownload = true
          this.mostraCantelli = true
          var datiDaInviare = { progetto: 'cantelli' }
          if (this.progettoCorrente == 'cantelli2024') {
            datiDaInviare['anno'] = '2024'
          } else {
            // cantelli 2026
            datiDaInviare['anno'] = '2026'
          }
          useJwt.post(apiRicercaSpesaUrl, datiDaInviare).then((r) => {
            console.log("spese progetto")
            console.log(r.data['consuntivo'])
            console.log(r.data['preventivo'])

            this.speseProgetti = r.data['consuntivo']
            this.preventivoSpese = r.data['preventivo']
            this.totaleConsuntivoEntrate = 0
            this.totaleConsuntivoUscite = 0

            // entrate
            if (this.speseProgetti['altre-entrate']) {
              this.speseProgetti['altre-entrate'].forEach((obj) => {
                this.totaleConsuntivoEntrate += +obj.importo
              })
            }
            if (this.speseProgetti['incassi']) {
              this.speseProgetti['incassi'].forEach((obj) => {
                this.totaleConsuntivoEntrate += +obj.importo
              })
            }
            if (this.speseProgetti['sponsorizzazioni']) {
              this.speseProgetti['sponsorizzazioni'].forEach((obj) => {
                this.totaleConsuntivoEntrate += +obj.importoIncassato
              })
            }

            console.log(this.preventivoSpese)
            this.totalePreventivoEntrate = this.preventivoSpese['contributi-pubblici'] + 
                                            this.preventivoSpese['contributi-privati'] +
                                            this.preventivoSpese['sponsorizzazioni'] +
                                            this.preventivoSpese['entrate-attivita']

            // uscite TODO
            if (this.speseProgetti['personale']) {
              this.speseProgetti['personale'].forEach((obj) => {
                this.totaleConsuntivoUscite += +obj.importo
              })
            }
            if (this.speseProgetti['ospitalita']) {
              this.speseProgetti['ospitalita'].forEach((obj) => {
                this.totaleConsuntivoUscite += +obj.importo
              })
            }
            if (this.speseProgetti['promozione']) {
              this.speseProgetti['promozione'].forEach((obj) => {
                this.totaleConsuntivoUscite += +obj.importo
              })
            }

            this.totalePreventivoUscite = this.preventivoSpese['personale'] + 
                                            this.preventivoSpese['ospitalita'] +
                                            this.preventivoSpese['promozione']

            this.scostamentoEntrate = this.totaleConsuntivoEntrate - this.totalePreventivoEntrate;
            if ((this.totalePreventivoEntrate > 0) && (this.totaleConsuntivoEntrate > 0)) {
              this.raggiungimentoPercEntrate = 100*this.totaleConsuntivoEntrate / this.totalePreventivoEntrate;
            } else { this.raggiungimentoPercEntrate = null; }

            this.scostamentoUscite = this.totaleConsuntivoUscite - this.totalePreventivoUscite;
            if ((this.totalePreventivoUscite > 0) && (this.totaleConsuntivoUscite > 0)) {
              this.raggiungimentoPercUscite = 100*this.totaleConsuntivoUscite / this.totalePreventivoUscite;
            } else { this.raggiungimentoPercUscite = null; }
          })
      }
    },

    // per dialogA

    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === "download") {
        // TODO da implementare
          const selectedRow = this.$refs.gridA.getSelectedRecords();
          useJwt.post(apiDistinteGeneraUrl, {'id': selectedRow[0].id}).then((d) => {
            console.log(d.data)

            const nomeFile = d.data['fileDocumento'].split('\\').pop().split('/').pop().split('?')[0]
            
            const link = document.createElement("a");
            link.href = d.data['fileDocumento']
            link.setAttribute("download", nomeFile);
            document.body.appendChild(link);
            link.click();
          })
      }
    },

    downloadXls: function() {
      // scarico statistiche spettacolo
      var datiDaInviare;
      if ((this.progettoCorrente != 'cantelli2024') && (this.progettoCorrente != 'cantelli2026')) {
        datiDaInviare = {
          progetto: this.progettoCorrente,
        };
      } else {
          datiDaInviare = { progetto: 'cantelli' }
          if (this.progettoCorrente == 'cantelli2024') {
            datiDaInviare['anno'] = '2024'
          } else {
            // cantelli 2026
            datiDaInviare['anno'] = '2026'
          }
      }
      useJwt.post(apiDownloadSpesaUrl, datiDaInviare, { responseType: "blob" }).then((r) => {
        let fileName = r.headers["content-disposition"].split("filename=")[1];
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
      }).catch((r) => {
        this.makeToast("primary", "FAILURE", "Errore nel download")
      });
    },
 
    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// seleziono il colore per evidenziare la riga selezionata
.e-grid td.e-active {
  background-color: #e5cbdd;
}
</style>
